import { useMemo } from 'react'
import { useQueryPrefectures } from 'hooks/masterData'
import { SelectOption } from 'types/common'

const usePrefectureOptions = (): SelectOption[] => {
  const prefectures = useQueryPrefectures()
  return useMemo(() => {
    const options: SelectOption[] = [{ label: 'その他地域一律', value: 'その他地域一律' }]
    prefectures.map((prefecture) => options.push({ label: prefecture.displayName, value: prefecture.displayName }))
    return options
  }, [prefectures])
}

export default usePrefectureOptions
